import { Box } from '@mui/system';
import InstallationCheckList from 'components/SS/installationCheckList';

function InstallationManagment() {
  return (
    <>
      <Box sx={{ p: { xs: 3, md: 5 } }}>
        {/* <Paper sx={{ flex: 1, p: { xs: 3, md: 5 } }}>
          <Ownership
            name="Tsamina Mina"
            email="tsaminamina@email.com"
            avatar={avatar6}
            lastLoginAt="2024-11-15 15:54"
          />
        </Paper> */}

        <Box>
          <InstallationCheckList />
        </Box>
      </Box>
    </>
  );
}

export default InstallationManagment;
